import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DocumentDataStore } from '../document-data/document-data.store';
import { Estimate } from './estimate.model';
import { IJobDialog, IState, selectFeature } from './estimate-data.reducer';
import { Observable } from 'rxjs';
import { getJobDialog } from '../estimate-data/estimate-data.reducer';
import { filter } from 'rxjs/operators';

@Injectable()
export class EstimateDataStore extends DocumentDataStore<IState, Estimate> {
  constructor(store: Store<any>) {
    super(store, selectFeature);
  }

  getJobDialog(): Observable<IJobDialog> {
    return this.store.select(getJobDialog()).pipe(filter(x => !!x));
  }
}
